<script lang="ts" setup></script>

<template>
  <svg width="198" height="50" viewBox="0 0 198 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5917_37469)">
      <path
        d="M33.8679 15.4558C32.3503 15.4558 30.6252 16.6666 30.0146 18.1624L24.3355 31.9563C23.7249 33.452 24.454 34.6628 25.9657 34.6628H33.6426C35.1602 34.6628 36.8853 33.452 37.4959 31.9563L43.1692 18.1624C43.7798 16.6666 43.0506 15.4558 41.5389 15.4558H33.8679Z"
        fill="#F40000"
      />
      <path
        d="M65.0498 1.02075H57.3195C55.8019 1.02075 54.0708 2.23158 53.4602 3.7273L37.395 42.5746C35.8952 46.1774 32.8955 49.0977 32.8955 49.0977H45.1786C46.6962 49.0977 48.4272 47.8869 49.0378 46.3911L66.6741 3.7273C67.2906 2.23158 66.5674 1.02075 65.0438 1.02075H65.0498Z"
        fill="#F40000"
      />
      <path
        d="M2.44883 49.0978H10.1791C11.6967 49.0978 13.4277 47.887 14.0383 46.3913L30.1036 7.54395C31.6034 3.94115 34.6031 1.02686 34.6031 1.02686H22.32C20.8024 1.02686 19.0713 2.23768 18.4607 3.73341L0.824514 46.3972C0.213915 47.893 0.937149 49.1038 2.45475 49.1038L2.44883 49.0978Z"
        fill="#F40000"
      />
      <path
        d="M89.1062 1.01514H92.0584V21.6645H89.1062V12.6782H77.5167V21.6645H74.5645V1.01514H77.5167V9.94201H89.1062V1.01514Z"
        fill="white"
      />
      <path
        d="M104.276 0.89624H106.351L115.599 21.6643H112.576L109.825 15.5449H101.028L98.4488 21.6643H95.4136L104.27 0.89624H104.276ZM108.616 12.9155L105.29 5.43684L102.201 12.9155H108.616Z"
        fill="white"
      />
      <path
        d="M135.334 1.01489H138.138V21.6642H135.601L121.812 5.76323V21.6642H119.038V1.01489H121.427L135.334 17.0524V1.01489Z"
        fill="white"
      />
      <path
        d="M141.884 0.985107H159.112V3.6145H151.921V21.6641H148.951V3.6145H141.878V0.985107H141.884Z"
        fill="white"
      />
      <path
        d="M162.989 1.01489H174.679V3.64428H165.941V9.94177H174.383V12.589H165.941V19.0052H174.964V21.6346H162.989V1.01489Z"
        fill="white"
      />
      <path
        d="M196.969 16.8745V20.1271C194.805 21.3083 192.303 21.9018 189.47 21.9018C187.17 21.9018 185.213 21.4389 183.607 20.5129C182 19.587 180.732 18.3109 179.801 16.6846C178.864 15.0583 178.396 13.3014 178.396 11.408C178.396 8.40467 179.469 5.87618 181.609 3.82846C183.749 1.78073 186.387 0.753906 189.529 0.753906C191.693 0.753906 194.1 1.32371 196.75 2.45144V5.62689C194.337 4.24987 191.983 3.55543 189.677 3.55543C187.371 3.55543 185.356 4.30329 183.797 5.79308C182.237 7.28287 181.455 9.15847 181.455 11.4021C181.455 13.6456 182.22 15.5331 183.755 16.9873C185.29 18.4474 187.253 19.1775 189.648 19.1775C192.043 19.1775 194.586 18.4118 196.969 16.8745Z"
        fill="white"
      />
      <path
        d="M90.5642 29.0537H93.2437V49.0976H90.3626V33.5053L84.2092 41.251H83.6816L77.457 33.5053V49.0976H74.5938V29.0537H77.3088L83.9602 37.2861L90.5701 29.0537H90.5642Z"
        fill="white"
      />
      <path
        d="M104.092 28.9409H106.108L115.083 49.0976H112.148L109.481 43.1563H100.938L98.4365 49.0976H95.4902L104.086 28.9409H104.092ZM108.301 40.604L105.07 33.345L102.076 40.604H108.301Z"
        fill="white"
      />
      <path
        d="M117.508 49.0976V29.0537H122.523C124.55 29.0537 126.157 29.5582 127.343 30.5613C128.534 31.5644 129.127 32.9236 129.127 34.633C129.127 35.8023 128.836 36.8113 128.256 37.6601C127.675 38.5088 126.839 39.1499 125.748 39.5653C126.388 39.9868 127.017 40.5625 127.627 41.2866C128.238 42.0107 129.097 43.2809 130.206 45.0912C130.905 46.2308 131.463 47.0855 131.884 47.6613L132.945 49.0976H129.536L128.665 47.78C128.635 47.7325 128.576 47.6494 128.493 47.5366L127.935 46.7472L127.046 45.2812L126.086 43.7142C125.493 42.8892 124.954 42.2363 124.462 41.7496C123.969 41.2629 123.525 40.9127 123.128 40.699C122.731 40.4853 122.067 40.3785 121.124 40.3785H120.377V49.1036H117.514L117.508 49.0976ZM121.231 31.4932H120.371V37.8203H121.462C122.914 37.8203 123.91 37.6957 124.45 37.4464C124.989 37.1971 125.41 36.8232 125.712 36.3187C126.015 35.8142 126.163 35.2444 126.163 34.6033C126.163 33.9623 125.997 33.3984 125.659 32.888C125.327 32.3775 124.853 32.0155 124.248 31.8018C123.643 31.5941 122.636 31.4872 121.231 31.4872V31.4932Z"
        fill="white"
      />
      <path
        d="M146.615 29.0535H150.195L141.511 38.5621L152.33 49.0915H148.417L138.185 39.1912V49.0915H135.322V29.0476H138.185V38.2119L146.609 29.0476L146.615 29.0535Z"
        fill="white"
      />
      <path
        d="M154.683 29.0537H166.03V31.6059H157.546V37.7194H165.745V40.2895H157.546V46.5157H166.302V49.068H154.683V29.0537Z"
        fill="white"
      />
      <path
        d="M167.796 29.0239H184.519V31.5762H177.542V49.0916H174.661V31.5762H167.796V29.0239Z"
        fill="white"
      />
      <path
        d="M192.327 40.6991L190.151 39.3755C188.788 38.5386 187.816 37.7195 187.235 36.9123C186.654 36.1051 186.369 35.1732 186.369 34.1227C186.369 32.5438 186.915 31.2618 188.011 30.2765C189.102 29.2912 190.525 28.7986 192.274 28.7986C194.022 28.7986 195.481 29.2675 196.874 30.2053V33.4638C195.433 32.0749 193.88 31.3805 192.214 31.3805C191.278 31.3805 190.507 31.5942 189.908 32.0275C189.31 32.4607 189.007 33.0187 189.007 33.6894C189.007 34.2888 189.227 34.8527 189.671 35.375C190.116 35.8973 190.827 36.4493 191.811 37.0251L193.999 38.319C196.441 39.7791 197.662 41.6369 197.662 43.8924C197.662 45.5009 197.123 46.8067 196.05 47.8097C194.977 48.8128 193.578 49.3173 191.859 49.3173C189.885 49.3173 188.082 48.706 186.458 47.4892V43.8449C188.005 45.8095 189.796 46.7888 191.829 46.7888C192.724 46.7888 193.471 46.5396 194.07 46.041C194.669 45.5424 194.965 44.9133 194.965 44.1595C194.965 42.9368 194.088 41.7853 192.327 40.6872V40.6991Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5917_37469">
        <rect width="198" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
